import { create } from 'zustand'
import { Dimensions, ScaledSize } from 'react-native'

type ToastState = {
    text: string
    visible: boolean
    setToast: (newText: string, isvisible: boolean) => void
    setToastEnd: () => void
}

export const useToast = create<ToastState>((set) => {
    return {
        text: '',
        visible: false,
        setToast: (newText, isvisible = true) =>
            set({
                text: newText,
                visible: isvisible,
            }),
        setToastEnd: () => set({ text: '', visible: false }),
    }
})
